import { RouteConfig } from "vue-router";
import IsAuthenticated from "@/permissions/IsAuthenticated";
import { redirectToGroupPage } from "./guards";

const routes: RouteConfig[] = [
    {
        path: "/",
        name: "home",
        component: require("@/views/Home.vue").default,
        beforeEnter: redirectToGroupPage,
        meta: {
            permissions: [IsAuthenticated()]
        }
    },
    {
        path: "/403",
        name: "403",
        component: require("@/views/PermissionDenied.vue").default,
        props: true
    },
    {
        path: "*",
        name: "404",
        component: require("@/views/NotFound.vue").default,
        props: true
    }
];

export default routes;
